<div class="newsletter-details-view-container" *ngIf="newsletterObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async)?.newsletter.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).newsletter.read" (click)="download()" mat-stroked-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz</span></button>
    <button [disabled]="!(userPermissions | async).newsletter.delete" (click)="deleteNewsletter()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane Newslettera</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa" [value]="newsletterObject?.newsletterName"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <ngx-extended-pdf-viewer
        *ngIf="newsletterObject"
        [src]="'/rest/crm/newsletter/' + newsletterObject.uuid  + '/pdf'"
        [zoom]="zoom"
        [backgroundColor]="'#fafafa'"
        [showPresentationModeButton]="true"

      ></ngx-extended-pdf-viewer>
    </div>
</div>
